var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManyDoctors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7143 21.3289C38.7143 25.6777 37.8841 28.1132 36.788 29.4543C35.7326 30.7455 34.2928 31.1842 32.5938 31.1842C30.7959 31.1842 29.3961 30.8939 28.3793 29.7264C27.3142 28.5035 26.4732 26.1008 26.4732 21.3289C26.4732 19.978 26.4963 19.072 26.6138 18.4274C26.7252 17.8161 26.893 17.6036 27.0667 17.4792C27.2996 17.3125 27.7437 17.1603 28.6979 17.0797C29.632 17.0008 30.8765 17 32.5938 17C34.311 17 35.5555 17.0008 36.4896 17.0797C37.4438 17.1603 37.8879 17.3125 38.1208 17.4792C38.2945 17.6036 38.4623 17.8161 38.5737 18.4274C38.6912 19.072 38.7143 19.978 38.7143 21.3289ZM34.756 50.1979L34.4398 51.1466L34.756 50.1979L20.6838 45.5072C20.2754 45.3711 20 44.9889 20 44.5585V42.546C20 41.7587 20.3802 40.9991 21.1702 40.258C21.9675 39.5101 23.1189 38.8468 24.4726 38.2956C27.1823 37.1924 30.4525 36.6381 32.5938 36.6381C34.5826 36.6381 37.5552 37.1168 40.1486 38.0759C41.4422 38.5543 42.598 39.1365 43.4786 39.8052C44.3645 40.4779 44.9007 41.1827 45.098 41.8916C45.1079 41.927 45.1116 41.9801 45.075 42.0668C45.0353 42.1609 44.9541 42.2748 44.8297 42.379L35.7144 50.0158C35.4483 50.2388 35.0855 50.3077 34.756 50.1979Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 20.75C27.6667 26.2803 26.5958 29.4367 25.127 31.2048C23.6966 32.9266 21.7436 33.5 19.5 33.5C17.1589 33.5 15.2451 33.1291 13.8526 31.5559C12.4153 29.9322 11.3333 26.8088 11.3333 20.75C11.3333 19.0436 11.3624 17.8726 11.5184 17.0297C11.6679 16.2226 11.9055 15.8767 12.2113 15.6613C12.579 15.4023 13.2202 15.205 14.4591 15.102C15.6774 15.0008 17.2948 15 19.5 15C21.7052 15 23.3226 15.0008 24.5409 15.102C25.7798 15.205 26.421 15.4023 26.7887 15.6613C27.0945 15.8767 27.3321 16.2225 27.4816 17.0297C27.6376 17.8726 27.6667 19.0436 27.6667 20.75ZM3 47.625C3 46.5376 3.53678 45.5111 4.59126 44.5379C5.65254 43.5584 7.17021 42.7019 8.93164 41.9962C12.4561 40.5843 16.7047 39.875 19.5 39.875C22.2953 39.875 26.5439 40.5843 30.0684 41.9962C31.8298 42.7019 33.3475 43.5584 34.4087 44.5379C35.4632 45.5111 36 46.5376 36 47.625V50C36 50.5523 35.5523 51 35 51H4C3.44772 51 3 50.5523 3 50V47.625Z",
    fill: "#A0CCEF",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 28,
    height: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManyDoctors);
export default __webpack_public_path__ + "static/media/manyDoctors.538a227c1f751f97f012bb9bdb609bc7.svg";
export { ForwardRef as ReactComponent };